module.exports = __webpack_public_path__ + "static/media/botright.ad569aa4.svg";